module.exports = __webpack_public_path__ + "static/img/4707150.745c0da.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/4707150.svg
// module id = tMRU
// module chunks = 1